import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const ResolutionUpdatedAuditItemDetails = ({ audit }) => {
  const { auditedChanges } = audit
  const { text } = auditedChanges
  const textFrom = text[0]
  const textTo = text[1]

  return (
    <div>
      <span>
        <AuditedUser audit={audit} /> updated the resolution:
      </span>
      <div className="mt-4">
        <div className="whitespace-pre-wrap">{ textFrom }</div>
        <p>→</p>
        <div className="whitespace-pre-wrap">{ textTo }</div>
      </div>
    </div>
  )
}

ResolutionUpdatedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default ResolutionUpdatedAuditItemDetails
